import { render } from "./assetsSelectModal.vue?vue&type=template&id=097eb450"
import script from "./assetsSelectModal.vue?vue&type=script&lang=js"
export * from "./assetsSelectModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__